import z from 'zod';

const upperString = z
	.string()
	.min(3)
	.max(20)
	.transform((val) => val.toUpperCase());

export const GamePresetSchema = z.object({
	id: z.uuid(),
	connectionCodes: z.array(upperString),
	bonusCodes: z.array(upperString),
});
export type GamePreset = z.infer<typeof GamePresetSchema>;
